<div class="fill-color-selector flex-row" (click)="$event.stopPropagation()">
  <div
    (click)="toggleSelector()"
    [matTooltip]="showSelector ? null : 'Fill (f)'"
  >
    <div
      *ngIf="currentColor; else noFill"
      class="color-sample"
      [ngStyle]="{ 'background-color': resolvedColor }"
    ></div>
    <ng-template #noFill>
      <div style="margin: 2px">
        <img
          style="width: 15px; position: relative; top: 2px"
          src="./assets/icons/no_fill_white.svg"
          alt=""
        />
      </div>
    </ng-template>
  </div>
</div>
